import useSWR from "swr";
import { JSON_FETCHER } from "@/components/fetcher";
import { ApiKey } from "@/components/models/ApiKey";

export default function useApiKeys(): {
  apiKeys: ApiKey[];
  isLoading: boolean;
  isError: any;
} {
  const { data, error } = useSWR(`/web_api/api_keys`, JSON_FETCHER);

  return {
    apiKeys: data?.api_keys || [],
    isLoading: !(data || error),
    isError: error,
  };
}
